/*
# Frontend JS | Vendor: FairVerify | App: Phoenix | Type: VisitorLeadFallbackLoader
# FairVerify Event Solutions (fairverify.de) based on GodMode Core - GodMode.Systems
# Copyright Tim Haymann, FairVerify Event Solutions GmbH.
# created 2026-03-13 by Codex
# last edited 2026-03-13 by Codex // optional runtime loader for the image fallback scanner
*/
let fallbackPromise = null

function loadScript(src) {
  return new Promise((resolve, reject) => {
    const existing = document.querySelector(`script[data-src="${src}"]`)
    if (existing) {
      if (existing.dataset.loaded === 'true') {
        resolve()
        return
      }
      existing.addEventListener('load', () => resolve(), { once: true })
      existing.addEventListener('error', () => reject(new Error(`Failed to load ${src}`)), { once: true })
      return
    }

    const script = document.createElement('script')
    script.src = src
    script.async = true
    script.dataset.src = src
    script.addEventListener('load', () => {
      script.dataset.loaded = 'true'
      resolve()
    }, { once: true })
    script.addEventListener('error', () => reject(new Error(`Failed to load ${src}`)), { once: true })
    document.head.appendChild(script)
  })
}

export async function loadVisitorLeadFallbackModule() {
  if (fallbackPromise) return fallbackPromise

  fallbackPromise = (async () => {
    try {
      // Load the optional fallback at runtime so it can be removed later without bundle work.
      await loadScript('/vendor/html5-qrcode.min.js')
      await loadScript('/visitor-lead-fallback.js')
      return window.VisitorLeadFallback || null
    } catch (error) {
      console.error('[visitor-lead] Failed to load fallback scanner module', error)
      fallbackPromise = null  // allow retry
      return null
    }
  })()

  return fallbackPromise
}
